module.exports = __webpack_public_path__ + "img/20220809164746.3f31194a.jpg";